module.exports = __webpack_public_path__ + "static/inex_one_logo-e33d0356102398d5fe7b3569e11e60f4.svg";